import { aiApiClient } from "@src/api/ai-api";
import { knowledgeKeys } from "@src/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

const getKnowledgeSymptoms = async (source?: string): Promise<string[]> => {
  const query = source ? `?source=${encodeURIComponent(source)}` : "";
  const { data } = await aiApiClient.get<{ symptoms: string[] }>(
    `/knowledge/documents/symptoms${query}`
  );

  return data.symptoms;
};

export const useGetKnowledgeSymptoms = (source?: string) =>
  useQuery({
    queryKey: knowledgeKeys.symptoms(source),
    queryFn: async () => getKnowledgeSymptoms(source),
    enabled: source === "pylon-solutions",
  });
